import React, { useEffect, useState } from "react";
import "./index.css";
import { IState } from "../../store/types";
import { styleClassName } from "../styleHelper";

const getStatus = (turn: number, maxTurn: number) => {
  let status = "";
  if (turn / maxTurn < 0.3) status = "is-error";
  else if (turn / maxTurn < 0.8) status = "is-warning";
  else if (turn / maxTurn <= 1) status = "is-primary";
  else status = "is-error";
  return status;
};

function TurnInfo({ turn }: { turn: IState["turn"] }) {
  const { battle: currentTurn, battleDuration: maxTurn } = turn;
  return (
    <div>
      <span className="nes-text is-primary">Turn: </span>
      <span className={`nes-text ${getStatus(currentTurn, maxTurn)}`}>
        {currentTurn}
      </span>
      <span>{` / ${maxTurn}`}</span>
    </div>
  );
}

const BATTLE_INTERVAL = 500;
function TurnAutoBattle({ onClick }: { onClick: () => void }) {
  const [autoBattle, setAutoBattle] = useState(false);
  useEffect(() => {
    let timerId: NodeJS.Timeout;
    if (autoBattle === true) timerId = setInterval(onClick, BATTLE_INTERVAL);
    return () => {
      clearInterval(timerId);
    };
  }, [autoBattle, onClick]);

  return (
    <label htmlFor="battle-auto-turn">
      <input
        id="battle-auto-turn"
        type="checkbox"
        className={styleClassName("nes-checkbox")}
        checked={autoBattle}
        onChange={() => setAutoBattle(!autoBattle)}
      />
      <span>Auto</span>
    </label>
  );
}

function BatttleEndTurn({
  onClick = () => {},
  turn
}: {
  onClick: () => void;
  turn: IState["turn"];
}) {
  return (
    <div className="battle-end-turn">
      <div>
        <TurnAutoBattle onClick={onClick} />
        <button type="button" className="nes-btn is-primary" onClick={onClick}>
          Next Turn
        </button>
      </div>
      <TurnInfo turn={turn} />
    </div>
  );
}

export default BatttleEndTurn;
